import React, { memo } from 'react';

import { Colors } from 'context';

/**
 * Кольцо доли закрытых навыков на карточке колонки (ТЗ 0070).
 *
 * 🔴 Это ВТОРОЙ канал к подписи «3 из 8», а не замена ей. Кольцо ловится
 * взглядом при беглом просмотре карты, дробь называет то же самое точно —
 * ни один из двух не работает без другого.
 *
 * ⚠️ Дуга рисуется через `strokeDasharray` на окружности, а не путём с `A`:
 * дуга ровно на 100% вырождается в путь нулевой длины («начало = конец»), и
 * полностью закрытая колонка осталась бы с пустым кольцом. Здесь полный круг
 * — это просто длина штриха, равная длине окружности.
 */
interface IClusterProgressRing {
  cx: number;
  cy: number;
  r: number;
  done: number;
  total: number;
}

export const ClusterProgressRing = memo(({ cx, cy, r, done, total }: IClusterProgressRing) => {
  // Пустая колонка — кольцо без дуги, а не деление на ноль.
  const share = total > 0 ? Math.min(Math.max(done / total, 0), 1) : 0;
  const circumference = 2 * Math.PI * r;

  return (
    <g aria-hidden focusable="false">
      <circle cx={cx} cy={cy} r={r} fill="none" stroke={Colors.system_gray} strokeWidth={3} />
      {share > 0 && (
        <circle
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke={Colors.signal_green}
          strokeWidth={3}
          strokeLinecap="round"
          strokeDasharray={`${circumference * share} ${circumference}`}
          // Отсчёт от двенадцати часов, как на любом индикаторе доли.
          transform={`rotate(-90 ${cx} ${cy})`}
        />
      )}
    </g>
  );
});
